var _path, _path2, _rect, _rect2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNarrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 18",
    style: {
      enableBackground: "new 0 0 20 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7,15.1C8,15.5,8,15.5,8.3,16l0.1,0.2c0.4-0.7,0.6-0.9,0.7-1h0.6l-1,1.4L9.9,18H9.3l-0.4-0.6l-0.2-0.3 c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1,0.1-0.3,0.4-0.3,0.5c-0.1,0.2-0.2,0.3-0.4,0.5c0,0.1-0.1,0.1-0.1,0.2H7l1.1-1.5l-1-1.4H7.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7,13.8c0.8,0,1.3,0.4,1.3,1.1c0,0.6-0.3,1-1.1,1.8c-0.3,0.3-0.6,0.6-1,0.9h2.3V18h-2.8v-0.5 c1.5-1.3,2.1-2,2.1-2.6c0-0.4-0.3-0.7-0.8-0.7c-0.4,0-0.7,0.2-0.7,0.8h-0.6c0-0.4,0.1-0.6,0.3-0.8C10.9,13.9,11.2,13.8,11.7,13.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    width: 2,
    height: 16
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13,4 17,8 13,12 13,9 7,9 7,12 3,8 7,4 7,7 13,7 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNarrow);
export default __webpack_public_path__ + "static/media/narrow.b2ad2c28c9782933facaf78afcd249e0.svg";
export { ForwardRef as ReactComponent };